import * as actionTypes from 'shared/store/action-types';

const showRegisterdModal = () => {
	return {
		type: actionTypes.SHOW_REGISTER_MODAL,
	};
};

const hideRegisterModal = () => {
	return {
		type: actionTypes.HIDE_REGISTER_MODAL,
	};
};

const showRegisterModalStep2 = () => {
	return {
		type: actionTypes.SHOW_REGISTER_MODAL_STEP2,
	};
};

export { showRegisterdModal, hideRegisterModal, showRegisterModalStep2 };
